<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <canvas
        id="myChartDevolucaoImpropriaVendedores"
        width="100"
        height="50"
      />
      <div
        v-if="exibirLegenda"
        id="legendaFatxLinha"
        class="text-center px-3"
      >
        <v-row
          align="center"
          class="ma-0"
          no-gutters
        >
          <v-col
            md="12"
            offset-md="1"
          >
            <v-row>
              <div
                v-for="status in colors"
                :key="status.status"
              >
                <v-avatar
                  class="mr-1"
                  :color="status.cor"
                  size="12"
                />
                <span
                  id="statusCor"
                  class="mr-3 font-weight-light"
                >{{ status.status }}</span>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardFaturamentoLinha',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      cores: [],
      myChart: {},
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectSupervisor: [],
      porcentagem: [],
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectResumo, selectMes, selectAno, selectSupervisor) {
        this.selectResumo = selectResumo
        this.selectMes = selectMes
        this.selectAno = selectAno
        this.selectSupervisor = selectSupervisor

        this.exibirLegenda = false

        this.porcentagem = []
        this.colors = []
        this.cores = []

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showGraficoDevolucaoImpropriasVendedores(this.selectResumo, this.selectMes, this.selectAno, this.selectSupervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            var mobile = !(window.innerWidth < 600)

            this.exibirLegenda = mobile

            this.colors = resposta.data.cores

            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.cores.push(cor)
            }

            this.porcentagem = resposta.data.porcentagem

            const ctx = document.getElementById('myChartDevolucaoImpropriaVendedores').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.devolucao,
                    backgroundColor: this.cores,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                cutoutPercentage: 70,
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const porcentagem = this.porcentagem[tooltipItem.index]

                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ' - ' + porcentagem + ' %'
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChartDevolucaoImpropriaVendedores {
      margin: -1rem 0 0 0
    }
  }

  @media screen
  and (min-width: 1380px) {
    #myChartDevolucaoImpropriaVendedores {
      margin: 7rem 0 0 0
    }
  }
</style>

<style lang="sass">
  #myChartDevolucaoImpropriaVendedores
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    width: 380
    height: 250
    margin: 5rem 0 0 0

  #legendaFatxLinha
    margin: 2rem 0 0 0
    font-size: 12px

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
